export const basicApolloToIdList = {
  CompetitionCategory: { keyFields: ['competitionCategoryId'] },
  CompetitionCategoryForDisplay: {
    keyFields: ['competitionCategoryForDisplayId'],
  },
  CompetitionDetails: { keyFields: ['competitionDetailsId'] },
  CompetitionDetailsForDisplay: {
    keyFields: ['competitionDetailsForDisplayId'],
  },
  CompetitionInvoice: { keyFields: ['competitionInvoiceId'] },
  CompetitionJudge: { keyFields: ['competitionJudgeId'] },
  CompetitionMember: { keyFields: ['competitionMemberId'] },
  CompetitionMemberDetails: { keyFields: ['competitionMemberDetailsId'] },
  CoverSetup: { keyFields: ['coverSetupId'] },
  KeywordsList: { keyFields: ['keywordsListId'] },
  MineLike: { keyFields: ['mineLikeId'] },
  MinePhotoInCompetition: { keyFields: ['minePhotoInCompetitionId'] },
  PhotoInCompetition: { keyFields: ['photoInCompetitionId'] },
  PhotoInCompetitionForAdmin: { keyFields: ['photoInCompetitionForAdminId'] },
  PhotoInCompetitionForDisplay: {
    keyFields: ['photoInCompetitionForDisplayId'],
  },
  QuickLink: { keyFields: ['quickLinkId'] },
  SoldFilesUniversalWatermarkConfig: {
    keyFields: ['soldFilesUniversalWatermarkConfigId'],
  },
  SoldFilesWatermarkConfig: { keyFields: ['soldFilesWatermarkConfigId'] },
  SoldFilesWatermarkConfigPosition: {
    keyFields: ['soldFilesWatermarkConfigPositionId'],
  },
  BuildBlockJob: { keyFields: ['buildBlockJobId'] },
  CoverBuildJob: { keyFields: ['coverBuildJobId'] },
  DeliveryMethod: { keyFields: ['deliveryMethodId'] },
  DeliveryPackageOption: { keyFields: ['deliveryPackageOptionId'] },
  DetailedOrderInQueue: { keyFields: ['detailedOrderInQueueId'] },
  EngravingJob: { keyFields: ['engravingJobId'] },
  FilePricing: { keyFields: ['filePricingId'] },
  JoinCoverWithBlockJob: { keyFields: ['joinCoverWithBlockJobId'] },
  OrderGroup: { keyFields: ['orderGroupId'] },
  PhotographerOrderOnMultipleShelvesInfo: {
    keyFields: ['photographerOrderOnMultipleShelvesInfoId'],
  },
  PremiumLabPrintJob: { keyFields: ['premiumLabPrintJobId'] },
  PrintAndFileConfig: { keyFields: ['printAndFileConfigId'] },
  PrintFormat: { keyFields: ['printFormatId'] },
  PrintMachine: { keyFields: ['printMachineId'] },
  PrintPaper: { keyFields: ['printPaperId'] },
  PrintsPricingList: { keyFields: ['printsPricingListId'] },
  Product: { keyFields: ['productId'] },
  ProductPackage: { keyFields: ['productPackageId'] },
  RetouchLevel: { keyFields: ['retouchLevelId'] },
  StockItem: { keyFields: ['stockItemId'] },
  StockProductInOrderGroup: { keyFields: ['stockProductInOrderGroupId'] },
  ZalamoPrintSessionConfig: { keyFields: ['zalamoPrintSessionConfigId'] },
  LabWorkflow: { keyFields: ['labWorkflowId'] },
  LabWorkflowForProduct: { keyFields: ['labWorkflowForProductId'] },
  Decoration: { keyFields: ['decorationId'] },
  DecorationDemo: { keyFields: ['decorationDemoId'] },
  DecorationFx: { keyFields: ['decorationFxId'] },
  Lab: { keyFields: ['labId'] },
  CampaignEvent: { keyFields: ['campaignEventId'] },
  Gallery: { keyFields: ['galleryId'] },
  ImageComment: { keyFields: ['imageCommentId'] },
  ImageImpression: { keyFields: ['imageImpressionId'] },
  MobileClientInvitation: { keyFields: ['mobileClientInvitationId'] },
  MobileNativeClientGallery: { keyFields: ['mobileNativeClientGalleryId'] },
  MobileNativeClientGalleryGroup: {
    keyFields: ['mobileNativeClientGalleryGroupId'],
  },
  MobileNativeClientImage: { keyFields: ['mobileNativeClientImageId'] },
  Profile: { keyFields: ['profileId'] },
  DeliveryAddressForClient: { keyFields: ['deliveryAddressForClientId'] },
  OwnPhotoWaitingForUpload: { keyFields: ['ownPhotoWaitingForUploadId'] },
  ProductOrderDetails: { keyFields: ['productOrderDetailsId'] },
  ZalamoPayPayment: { keyFields: ['zalamoPayPaymentId'] },
  Organization: { keyFields: ['organizationId'] },
  OrganizationInvoiceDetails: { keyFields: ['organizationInvoiceDetailsId'] },
  ListForMatch: { keyFields: ['listForMatchId'] },
  ListWaitingForPhotoFaceMatch: {
    keyFields: ['listWaitingForPhotoFaceMatchId'],
  },
  PersonForFaceMatch: { keyFields: ['personForFaceMatchId'] },
  PhotoForFaceMatch: { keyFields: ['photoForFaceMatchId'] },
  DecorationField: { keyFields: ['decorationFieldId'] },
  DecorationForClient: { keyFields: ['decorationForClientId'] },
  DecorationPreConfigForClient: {
    keyFields: ['decorationPreConfigForClientId'],
  },
  LookBookProductConfig: { keyFields: ['lookBookProductConfigId'] },
  PhotoComment: { keyFields: ['photoCommentId'] },
  PrintsPricingListForDisplay: { keyFields: ['printsPricingListForDisplayId'] },
  PrivateSessionClient: { keyFields: ['privateSessionClientId'] },
  SessionPrintFrameConfig: { keyFields: ['sessionPrintFrameConfigId'] },
  StateBasket: { keyFields: ['stateBasketId'] },
  TriplexRenderPreviewConfig: { keyFields: ['triplexRenderPreviewConfigId'] },
  WallDecorRenderPreviewConfig: {
    keyFields: ['wallDecorRenderPreviewConfigId'],
  },
  CalendarForDisplay: { keyFields: ['calendarForDisplayId'] },
  DeliveryAddress: { keyFields: ['deliveryAddressId'] },
  FileWatermark: { keyFields: ['fileWatermarkId'] },
  MagnetForDisplay: { keyFields: ['magnetForDisplayId'] },
  Photo: { keyFields: ['photoId'] },
  TabloForDisplay: { keyFields: ['tabloForDisplayId'] },
  ConfigTemplate: { keyFields: ['configTemplateId'] },
  DecorationPreConfig: { keyFields: ['decorationPreConfigId'] },
  ImageList: { keyFields: ['imageListId'], fields: { files: {} } },
  ImagesCount: { keyFields: ['imagesCountId'] },
  LocalClient: { keyFields: ['localClientId'] },
  LocalClientConfig: { keyFields: ['localClientConfigId'] },
  LocalClientSubTask: { keyFields: ['localClientSubTaskId'] },
  LocalClientTaskSet: { keyFields: ['localClientTaskSetId'] },
  LookBook: { keyFields: ['lookBookId'] },
  LookBookOrder: { keyFields: ['lookBookOrderId'] },
  PersonToPhotoRelation: { keyFields: ['personToPhotoRelationId'] },
  PhotoInGroup: { keyFields: ['photoInGroupId'] },
  PrivateSession: { keyFields: ['privateSessionId'] },
  PrivateSessionClientBasket: { keyFields: ['privateSessionClientBasketId'] },
  PrivateSessionGroup: { keyFields: ['privateSessionGroupId'] },
  PrivateSessionGroupTemplate: { keyFields: ['privateSessionGroupTemplateId'] },
  PublicNiceUrlRedirect: { keyFields: ['publicNiceUrlRedirectId'] },
  PublicSession: { keyFields: ['publicSessionId'] },
  PublicSessionChild: { keyFields: ['publicSessionChildId'] },
  PublicSessionGroup: { keyFields: ['publicSessionGroupId'] },
  PublicSessionGroupMembersList: {
    keyFields: ['publicSessionGroupMembersListId'],
  },
  PublicSessionGroupTemplate: { keyFields: ['publicSessionGroupTemplateId'] },
  PublicSessionOrganization: { keyFields: ['publicSessionOrganizationId'] },
  PublicSessionOrganizationGroup: {
    keyFields: ['publicSessionOrganizationGroupId'],
  },
  PublicSessionOrganizationGroupsList: {
    keyFields: ['publicSessionOrganizationGroupsListId'],
  },
  PublicSessionOrganizationMember: {
    keyFields: ['publicSessionOrganizationMemberId'],
  },
  PublicSessionOrganizationRole: {
    keyFields: ['publicSessionOrganizationRoleId'],
  },
  PublicSessionSignupCampaign: { keyFields: ['publicSessionSignupCampaignId'] },
  PublicSessionSignupCampaignGroup: {
    keyFields: ['publicSessionSignupCampaignGroupId'],
  },
  PublicSessionSignupCampaignPackage: {
    keyFields: ['publicSessionSignupCampaignPackageId'],
  },
  PublicSessionSignupCampaignPackageAssignment: {
    keyFields: ['publicSessionSignupCampaignPackageAssignmentId'],
  },
  PublicSessionSignupCampaignShootDay: {
    keyFields: ['publicSessionSignupCampaignShootDayId'],
  },
  PublicSessionSignupCommunicationBatch: {
    keyFields: ['publicSessionSignupCommunicationBatchId'],
  },
  PublicSessionSignupCommunicationDelivery: {
    keyFields: ['publicSessionSignupCommunicationDeliveryId'],
  },
  PublicSessionSignupCommunicationEvent: {
    keyFields: ['publicSessionSignupCommunicationEventId'],
  },
  PublicSessionSignupCommunicationOverview: {
    keyFields: ['publicSessionSignupCommunicationOverviewId'],
  },
  PublicSessionSignupCommunicationPath: {
    keyFields: ['publicSessionSignupCommunicationPathId'],
  },
  PublicSessionSignupCommunicationRule: {
    keyFields: ['publicSessionSignupCommunicationRuleId'],
  },
  PublicSessionSignupCommunicationTemplate: {
    keyFields: ['publicSessionSignupCommunicationTemplateId'],
  },
  PublicSessionSignupConsentDefinition: {
    keyFields: ['publicSessionSignupConsentDefinitionId'],
  },
  PublicSessionSignupCreateSessionsResult: {
    keyFields: ['publicSessionSignupCreateSessionsResultId'],
  },
  PublicSessionSignupImportChild: {
    keyFields: ['publicSessionSignupImportChildId'],
  },
  PublicSessionSignupPackage: { keyFields: ['publicSessionSignupPackageId'] },
  PublicSessionSignupPrepaymentInitiation: {
    keyFields: ['publicSessionSignupPrepaymentInitiationId'],
  },
  PublicSessionSignupSessionInviteWorkflowTriggerResult: {
    keyFields: ['publicSessionSignupSessionInviteWorkflowTriggerResultId'],
  },
  PublicSessionSignupSubmission: {
    keyFields: ['publicSessionSignupSubmissionId'],
  },
  PublicSessionSignupSubmissionChild: {
    keyFields: ['publicSessionSignupSubmissionChildId'],
  },
  PublicSessionSignupSubmissionEditPayload: {
    keyFields: ['publicSessionSignupSubmissionEditPayloadId'],
  },
  PublicSessionSignupSubmissionMutationResult: {
    keyFields: ['publicSessionSignupSubmissionMutationResultId'],
  },
  AlbumSizeImagesOnSpreadLimit: {
    keyFields: ['albumSizeImagesOnSpreadLimitId'],
  },
  OrganizationEmbedConfig: { keyFields: ['organizationEmbedConfigId'] },
  BackPrintConfig: { keyFields: ['backPrintConfigId'] },
  Campaign: { keyFields: ['campaignId'] },
  CampaignAuditLog: { keyFields: ['campaignAuditLogId'] },
  CampaignAuditLogList: { keyFields: ['campaignAuditLogListId'] },
  CampaignConflictLog: { keyFields: ['campaignConflictLogId'] },
  CampaignConflictLogList: { keyFields: ['campaignConflictLogListId'] },
  CampaignCreativeAssetList: { keyFields: ['campaignCreativeAssetListId'] },
  CampaignDailyJobResult: { keyFields: ['campaignDailyJobResultId'] },
  CampaignDecisionLogList: { keyFields: ['campaignDecisionLogListId'] },
  CampaignFeatureSnapshotList: { keyFields: ['campaignFeatureSnapshotListId'] },
  CampaignHoldoutList: { keyFields: ['campaignHoldoutListId'] },
  CampaignList: { keyFields: ['campaignListId'] },
  CampaignLongHorizonAttributionList: {
    keyFields: ['campaignLongHorizonAttributionListId'],
  },
  CampaignMessageTemplateList: { keyFields: ['campaignMessageTemplateListId'] },
  CampaignMetricsDaily: { keyFields: ['campaignMetricsDailyId'] },
  CampaignMetricsDailyList: { keyFields: ['campaignMetricsDailyListId'] },
  CampaignModelDriftReportList: {
    keyFields: ['campaignModelDriftReportListId'],
  },
  CampaignModelExplanationList: {
    keyFields: ['campaignModelExplanationListId'],
  },
  CampaignOptimizationModelStateList: {
    keyFields: ['campaignOptimizationModelStateListId'],
  },
  CampaignPlacementPolicyList: { keyFields: ['campaignPlacementPolicyListId'] },
  CampaignPricingRuleList: { keyFields: ['campaignPricingRuleListId'] },
  CampaignSegmentList: { keyFields: ['campaignSegmentListId'] },
  CampaignWarehouseExportList: { keyFields: ['campaignWarehouseExportListId'] },
  CompletedPersonState: { keyFields: ['completedPersonStateId'] },
  MainMenuSortOrder: { keyFields: ['mainMenuSortOrderId'] },
  MainMenuVisibility: { keyFields: ['mainMenuVisibilityId'] },
  MobileClientPhotoMarkupConfig: {
    keyFields: ['mobileClientPhotoMarkupConfigId'],
  },
  OrganizationMember: { keyFields: ['organizationMemberId'] },
  PhotographerPublicStateFieldValue: {
    keyFields: ['photographerPublicStateFieldValueId'],
  },
  PrintFlyerConfig: { keyFields: ['printFlyerConfigId'] },
  PromoPrintFlyer: { keyFields: ['promoPrintFlyerId'] },
  PublicSessionSignupCreateTrackedShootingsResult: {
    keyFields: ['publicSessionSignupCreateTrackedShootingsResultId'],
  },
  QuickCover: { keyFields: ['quickCoverId'] },
  TabloMemberPhotoPosition: { keyFields: ['tabloMemberPhotoPositionId'] },
  TabloProject: { keyFields: ['tabloProjectId'] },
  TrackedShooting: { keyFields: ['trackedShootingId'] },
  TrackedShootingCamera: { keyFields: ['trackedShootingCameraId'] },
  TrackedShootingTimelineEntry: {
    keyFields: ['trackedShootingTimelineEntryId'],
  },
  Event: { keyFields: ['eventId'] },
  MarketplaceOrder: { keyFields: ['marketplaceOrderId'] },
  MarketplacePackageTemplate: { keyFields: ['marketplacePackageTemplateId'] },
  ZalamoMarketProduct: { keyFields: ['zalamoMarketProductId'] },
  Comment: { keyFields: ['commentId'] },
  CommentsList: { keyFields: ['commentsListId'] },
  ConversationStatus: { keyFields: ['conversationStatusId'] },
  MineStatus: { keyFields: ['mineStatusId'] },
  OldSessionDetails: { keyFields: ['oldSessionDetailsId'] },
  OldUserDetails: { keyFields: ['oldUserDetailsId'] },
  PaymentMethod: { keyFields: ['paymentMethodId'] },
  ProductForProofing: { keyFields: ['productForProofingId'] },
  SchoolDetails: { keyFields: ['schoolDetailsId'] },
  StandaloneSupportMessage: { keyFields: ['standaloneSupportMessageId'] },
  SupportRequest: { keyFields: ['supportRequestId'] },
  SupportRequestList: { keyFields: ['supportRequestListId'] },
  SupportTeamMember: { keyFields: ['supportTeamMemberId'] },
  SupportThreadAiSuggestion: { keyFields: ['supportThreadAiSuggestionId'] },
  SupportedClientIdentifier: { keyFields: ['supportedClientIdentifierId'] },
  UserHasConversation: { keyFields: ['userHasConversationId'] },
  ZalamoKnowledgeBaseEntry: { keyFields: ['zalamoKnowledgeBaseEntryId'] },
  BookingPackageAddition: { keyFields: ['bookingPackageAdditionId'] },
  BookingPackageComponent: { keyFields: ['bookingPackageComponentId'] },
  BookingPhotoPackage: { keyFields: ['bookingPhotoPackageId'] },
  BookingSessionCategory: { keyFields: ['bookingSessionCategoryId'] },
  PhotoPackage: { keyFields: ['photoPackageId'] },
  ScheduleEvent: { keyFields: ['scheduleEventId'] },
  SessionCategory: { keyFields: ['sessionCategoryId'] },
  UsedBookingPackageAddition: { keyFields: ['usedBookingPackageAdditionId'] },
  WorkingHour: { keyFields: ['workingHourId'] },
  BookingCategoryForDisplay: { keyFields: ['bookingCategoryForDisplayId'] },
  BookingPackageComponentForDisplay: {
    keyFields: ['bookingPackageComponentForDisplayId'],
  },
  BookingPackageForDisplay: { keyFields: ['bookingPackageForDisplayId'] },
  ClientReservationForDisplay: { keyFields: ['clientReservationForDisplayId'] },
  ScheduleEventForDisplay: { keyFields: ['scheduleEventForDisplayId'] },
  WorkingHourForDisplay: { keyFields: ['workingHourForDisplayId'] },
  EventDetails: { keyFields: ['eventDetailsId'] },
  UserEvent: { keyFields: ['userEventId'] },
  Font: { keyFields: ['fontId'] },
  GltfModel: { keyFields: ['gltfModelId'] },
  GltfModelCoveredSurface: { keyFields: ['gltfModelCoveredSurfaceId'] },
  GltfModelImageSurface: { keyFields: ['gltfModelImageSurfaceId'] },
  MaterialDefinition: { keyFields: ['materialDefinitionId'] },
  NotificationStatus: { keyFields: ['notificationStatusId'] },
  ObjectName: { keyFields: ['objectNameId'] },
  OrganizationClient: { keyFields: ['organizationClientId'] },
  BuyerDetails: { keyFields: ['buyerDetailsId'] },
  DeliveryDetails: { keyFields: ['deliveryDetailsId'] },
  DigitalFileInOrder: { keyFields: ['digitalFileInOrderId'] },
  DigitalOrder: { keyFields: ['digitalOrderId'] },
  FilesInDigitalOrder: { keyFields: ['filesInDigitalOrderId'] },
  FilesInPrintsOrder: { keyFields: ['filesInPrintsOrderId'] },
  LockerDetails: { keyFields: ['lockerDetailsId'] },
  LookBookOrderProductDetails: { keyFields: ['lookBookOrderProductDetailsId'] },
  Order: { keyFields: ['orderId'] },
  OrderInvoiceDetails: { keyFields: ['orderInvoiceDetailsId'] },
  PhotoInOrder: { keyFields: ['photoInOrderId'] },
  PrintInOrder: { keyFields: ['printInOrderId'] },
  PrintsOrder: { keyFields: ['printsOrderId'] },
  PrintsOrderedStatusUpdate: { keyFields: ['printsOrderedStatusUpdateId'] },
  ProductOrder: { keyFields: ['productOrderId'] },
  PromoCode: { keyFields: ['promoCodeId'] },
  PromoCodesCount: { keyFields: ['promoCodesCountId'] },
  OrdersInSupplierBasketList: { keyFields: ['ordersInSupplierBasketListId'] },
  PhotoInWallDecorOrder: { keyFields: ['photoInWallDecorOrderId'] },
  PrintInSupplierBasket: { keyFields: ['printInSupplierBasketId'] },
  PrintInSupplierBasketForZalamo: {
    keyFields: ['printInSupplierBasketForZalamoId'],
  },
  PrintOrderPrice: { keyFields: ['printOrderPriceId'] },
  PrintsOrderSubOrder: { keyFields: ['printsOrderSubOrderId'] },
  ProductInZalamoPrintOrder: { keyFields: ['productInZalamoPrintOrderId'] },
  Supplier: { keyFields: ['supplierId'] },
  SupplierAvailableProduct: { keyFields: ['supplierAvailableProductId'] },
  SupplierBasket: { keyFields: ['supplierBasketId'] },
  SupplierDownloadState: { keyFields: ['supplierDownloadStateId'] },
  SupplierOrderStateDetails: { keyFields: ['supplierOrderStateDetailsId'] },
  SupplierPlacedOrder: { keyFields: ['supplierPlacedOrderId'] },
  SupplierPrintConfig: { keyFields: ['supplierPrintConfigId'] },
  SupplierPrintPricing: { keyFields: ['supplierPrintPricingId'] },
  SuppliersList: { keyFields: ['suppliersListId'] },
  TriplexSupplierSubOrder: { keyFields: ['triplexSupplierSubOrderId'] },
  WallArtOrderSubOrder: { keyFields: ['wallArtOrderSubOrderId'] },
  WallDecorSupplierOrderDetails: {
    keyFields: ['wallDecorSupplierOrderDetailsId'],
  },
  WallDecorSupplierSubOrder: { keyFields: ['wallDecorSupplierSubOrderId'] },
  WallDecorSupplierSubOrderImage: {
    keyFields: ['wallDecorSupplierSubOrderImageId'],
  },
  ZalamoPrintOrderForPhotographer: {
    keyFields: ['zalamoPrintOrderForPhotographerId'],
  },
  Tos: { keyFields: ['tosId'] },
  VisualGuide: { keyFields: ['visualGuideId'] },
  VisualGuideStep: { keyFields: ['visualGuideStepId'] },
  WallDecorConfig: { keyFields: ['wallDecorConfigId'] },
  WallDecorSceneForDisplay: { keyFields: ['wallDecorSceneForDisplayId'] },
  WallDecorPiece: { keyFields: ['wallDecorPieceId'] },
  WallDecorScene: { keyFields: ['wallDecorSceneId'] },
  ZalamoInlineHelp: { keyFields: ['zalamoInlineHelpId'] },
  CategoryParentForDisplay: { keyFields: ['categoryParentForDisplayId'] },
  CategoryTreeForDisplay: { keyFields: ['categoryTreeForDisplayId'] },
  PageInfoForDisplay: { keyFields: ['pageInfoForDisplayId'] },
  ZalamoMarketCategoryForDisplay: {
    keyFields: ['zalamoMarketCategoryForDisplayId'],
  },
  ZalamoMarketProductForDisplay: {
    keyFields: ['zalamoMarketProductForDisplayId'],
  },
  ZalamoProductConnectionForDisplay: {
    keyFields: ['zalamoProductConnectionForDisplayId'],
  },
  ZalamoProductEdgeForDisplay: { keyFields: ['zalamoProductEdgeForDisplayId'] },
  SupportMember: { keyFields: ['supportMemberId'] },
  SingleProductInOrder: { keyFields: ['productInOrderId'] },
  SinglePhoto: { keyFields: ['photoId'] },
  PublicSessionForDisplay: { keyFields: ['publicSessionId'] },
  SupplierPrintsOrder: { keyFields: ['printsOrderId'] },
  SupplierPrintPaper: { keyFields: ['printPaperId'] },
  SupplierPrintFormat: { keyFields: ['printFormatId'] },
  OrderToSentToSupplier: { keyFields: ['printOrderId'] },
  PhotographerAccount: { keyFields: ['photographerId'] },
  ZalamoSupportThread: { keyFields: ['supportThreadId'] },
  TosForClient: { keyFields: ['tosRevisionId'] },
  AlbumAvgImagesPerSpread: { keyFields: ['configId'] },
  FileInPrivateSessionBasket: { keyFields: ['photoId'] },
  ImageSuggestion: { keyFields: ['photoId'] },
  PhotoSuggestionForDisplay: { keyFields: ['photoId'] },
  MineAvatarDetails: { keyFields: ['userId'] },
  PublicSessionTemplate: { keyFields: ['configTemplateId'] },
  PrivateSessionTemplate: { keyFields: ['configTemplateId'] },
  UserVisualGuideState: { keyFields: ['visualGuideId'] },
  ProductDetails: { keyFields: ['productInOrderId'] },
  PlacedOrderDetails: { keyFields: ['hash'] },
  ProductInZalamoPrintOrderFull: { keyFields: ['productInZalamoPrintOrderId'] },
  PublicSessionChildrenList: {
    keyFields: ['publicSessionOrganizationGroupId'],
  },
  TabloProjectChild: { keyFields: ['childId'] },
  OrderReadyToPackage: { keyFields: ['orderId'] },
  TrackedShootingStateForPhotographer: { keyFields: ['trackedShootingId'] },
  OrderReadyToPrint: { keyFields: ['orderId'] },
  CoverBuildJobFull: { keyFields: ['coverBuildJobId'] },
  PrintInBasket: { keyFields: ['printInOrderId'] },
  PublicSessionOrganizationSettings: {
    keyFields: ['publicSessionOrganizationId'],
  },
}
